export default __webpack_public_path__ + "static/media/plain-background.fd7bbecc.jpeg";